import React from 'react'
import { useTranslation } from 'react-i18next'

const FallbackComponent = () => {
  const { t } = useTranslation()
  return <div>{t('common.label.loading', 'Loading...')}</div>
}

export default FallbackComponent
